<template>
  <el-dialog title="交接班记录详情" :visible.sync="innerVisible" width="86%" top="5vh" append-to-body class="handover-detail-dialog">
    <div v-loading="loading">
      <el-descriptions :column="4" border size="small">
        <el-descriptions-item label="记录日期">{{ detail.recordDate || "-" }}</el-descriptions-item>
        <el-descriptions-item label="班组">{{ detail.teamName || detail.teamNo || "-" }}</el-descriptions-item>
        <el-descriptions-item label="班次">{{ detail.shiftName || detail.shiftNo || "-" }}</el-descriptions-item>
        <el-descriptions-item label="时间段">{{ timeRange || "-" }}</el-descriptions-item>
        <el-descriptions-item label="记录人">{{ detail.recordUserName || "-" }}</el-descriptions-item>
        <el-descriptions-item label="作业车列数">{{ formatValue(detail.workTrainCount) }}</el-descriptions-item>
        <el-descriptions-item label="作业车节数">{{ formatValue(detail.workCarCount) }}</el-descriptions-item>
        <el-descriptions-item label="热电卸煤量">{{ formatValue(detail.thermalPowerUnloadWeight) }}</el-descriptions-item>
        <el-descriptions-item label="煤棚卸煤量">{{ formatValue(detail.coalShedUnloadWeight) }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detail.createTime || "-" }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">{{ detail.remark || "-" }}</el-descriptions-item>
      </el-descriptions>

      <div class="section-title">交接班记录明细</div>
      <el-table :data="detail.itemList || []" border size="small" empty-text="暂无明细">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="recordTime" label="时间" width="120" />
        <el-table-column prop="workContent" label="工作内容" min-width="220" show-overflow-tooltip />
        <el-table-column prop="handleStatus" label="处理情况" min-width="200" show-overflow-tooltip />
        <el-table-column prop="handoverMatter" label="交接事项" min-width="200" show-overflow-tooltip />
      </el-table>
    </div>
    <div slot="footer">
      <el-button size="small" @click="innerVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getDetail } from "../api";

export default {
  name: "HandoverDetailDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    recordId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      detail: {},
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    timeRange() {
      return this.detail.startTime && this.detail.endTime ? `${this.detail.startTime}-${this.detail.endTime}` : "";
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.loadDetail();
      }
    },
  },
  methods: {
    async loadDetail() {
      if (!this.recordId) {
        this.detail = {};
        return;
      }
      this.loading = true;
      try {
        const res = await getDetail(this.recordId);
        this.detail = (res.data && res.data.data) || {};
      } finally {
        this.loading = false;
      }
    },
    formatValue(value) {
      return value === 0 || value ? value : "-";
    },
  },
};
</script>

<style scoped lang="scss">
.handover-detail-dialog {
  ::v-deep .el-dialog__body {
    max-height: 72vh;
    overflow: auto;
  }
}

.section-title {
  margin: 18px 0 12px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
  color: #1f2d3d;
  font-size: 15px;
  font-weight: 700;
  line-height: 18px;
}
</style>
